var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlinestep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_136_13545_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 25.7227C14.9816 25.7227 15.7773 26.5184 15.7773 27.5C15.7773 28.4816 14.9816 29.2773 14 29.2773C13.0184 29.2773 12.2227 28.4816 12.2227 27.5C12.2227 26.5184 13.0184 25.7227 14 25.7227ZM25 25.7227C25.9816 25.7227 26.7773 26.5184 26.7773 27.5C26.7773 28.4816 25.9816 29.2773 25 29.2773C24.0184 29.2773 23.2227 28.4816 23.2227 27.5C23.2227 26.5184 24.0184 25.7227 25 25.7227ZM8.33984 6.72266C9.67755 6.72266 10.8525 7.53149 11.3564 8.72266H25.9951C28 8.72266 29.5356 10.5068 29.2363 12.4893L28.3301 18.4893C28.088 20.0921 26.7099 21.2773 25.0889 21.2773H13.7891L13.7969 21.3174C13.9496 22.1322 14.6613 22.7227 15.4902 22.7227H26C26.7054 22.7227 27.2773 23.2946 27.2773 24C27.2773 24.7054 26.7054 25.2773 26 25.2773H15.4902C13.4319 25.2773 11.6655 23.8111 11.2861 21.7881L9.05078 9.86719C8.98669 9.52539 8.6876 9.27734 8.33984 9.27734H8C7.29455 9.27734 6.72266 8.70545 6.72266 8C6.72266 7.29455 7.29455 6.72266 8 6.72266H8.33984Z",
    fill: "url(#paint0_linear_136_13545)",
    stroke: "#141C2A",
    strokeWidth: 0.554666
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_136_13545_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_13545",
    x1: 17.998,
    y1: 7,
    x2: 17.998,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FED7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2D12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinestep2);
export default __webpack_public_path__ + "static/media/onlinestep2.23ad4e79cbee15120d9d696ce3b62f4d.svg";
export { ForwardRef as ReactComponent };